// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd1-cls1_x4L","cls2":"PodcastLibraryAd1-cls2_kRO PodcastLibraryAd1-cls1_x4L"};